<script lang="ts">
  export let placeholder: string;
  export let value = "";
  export let isDisabled: boolean = false;

  export let onChange: ((value: string) => void) | undefined = undefined;

  const handleValueChange = (event: Event) => {
    const target = event.target as HTMLInputElement;

    if (onChange) {
      onChange(target.value);
    }
  };
</script>

<div class="relative my-2">
  <textarea bind:value class="w-full" disabled={isDisabled} on:input={handleValueChange} />
  <span class="w-full floating-label" class:small={String(value)?.trim()}>{placeholder}</span>
</div>

<style>
  .floating-label {
    position: absolute;
    top: 0;
    left: 1rem;
    transition: all 0.2s;
    color: var(--color-grayscale-70);
    pointer-events: none;
    width: calc(100% - 2rem);
    background-color: var(--color-grayscale-20);
    padding-top: 1rem;
  }

  textarea:focus + .floating-label,
  .floating-label.small {
    top: 0;
    padding-top: 0.5rem;
    font-size: 0.75rem;
  }

  textarea {
    border: none;
    outline: none;
    background-color: var(--color-grayscale-20);
    border-radius: 0.75rem;
    padding: 1.5rem 1rem 0.5rem 1rem;
  }

  textarea:disabled {
    cursor: not-allowed;
  }
</style>
